import {LanguageOption} from '../model/language-option.model';

export const LANGUAGE_OPTIONS: LanguageOption[] = [
  {value: 'de', viewValue: 'Deutsch', flagIconClass: 'fi fi-de'},
  {value: 'en', viewValue: 'English', flagIconClass: 'fi fi-gb'},
  {value: 'tr', viewValue: 'Türkçe', flagIconClass: 'fi fi-tr'}
];
